import React from 'react';
import {
  Form,
  Table,
  Row,
  Col,
  Button,
  Card,
  ButtonGroup,
  Modal,
  Spinner,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import md5 from 'md5';
import { Chart } from 'react-google-charts';
import { parseISO, format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import { getRandomColor } from '../../../helpers/documentos/laboratorio';
import { prefixo } from '../../../util/utils';

const ExamesLaboratoriaisModal = ({
  show,
  onHide,
  atual,
  isLoadingExames = false,
  showGraficoExamesLab,
  setShowGraficoExamesLab,
  showTabelaExamesLab,
  setShowTabelaExamesLab,
  showTodosExamesLab,
  setShowTodosExamesLab,
  laboratoriais,
  setLaboratoriais,
  viewexames = [],
  tabelaexames,
  chartExames,
  tableExames,
  uniqueExames,
  toggleValor,
  toggleResultado,
  handleExibirResultadoExames,
  handleExibirTabelaExames,
  handleExcluirZerados,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" scrollable>
      <Modal.Header closeButton className="font-weight-bold">
        EXAMES LABORATORIAIS DE {atual?.NOMEPAC} - DT NASC: {atual?.dataNasc}
      </Modal.Header>
      <Modal.Body>
        {isLoadingExames ? (
          <div
            className="d-flex justify-content-center align-items-center py-5"
            style={{ minHeight: 240 }}
          >
            <Spinner
              animation="border"
              role="status"
              aria-label="Carregando exames laboratoriais"
            />
          </div>
        ) : (
          <div>
            <div className="alert alert-warning text-center">
              <Button
                variant={showGraficoExamesLab ? 'primary' : 'outline-primary'}
                onClick={() => setShowGraficoExamesLab(!showGraficoExamesLab)}
              >
                {showGraficoExamesLab
                  ? 'Fechar Gráfico de Exames'
                  : 'Gráfico de Exames Laboratoriais'}
              </Button>{' '}
              <Button
                variant={showTabelaExamesLab ? 'warning' : 'outline-warning'}
                onClick={() => setShowTabelaExamesLab(!showTabelaExamesLab)}
              >
                {showTabelaExamesLab
                  ? 'Fechar Tabela de Exames'
                  : 'Tabela de Exames Laboratoriais'}
              </Button>{' '}
              <Button
                variant={showTodosExamesLab ? 'success' : 'outline-success'}
                onClick={() => setShowTodosExamesLab(!showTodosExamesLab)}
              >
                {showTodosExamesLab
                  ? 'Fechar Todos Exames'
                  : 'Todos os Exames Laboratoriais'}
              </Button>
            </div>
            {showGraficoExamesLab && (
              <Row>
                <Col sm={2}>
                  {viewexames.length > 0 && (
                    <ButtonGroup vertical>
                      {viewexames.map((exame, index) => (
                        <Button
                          size="sm"
                          variant="outline-primary"
                          key={index}
                          onClick={() => handleExibirResultadoExames(exame)}
                        >
                          {exame.EXAME}
                        </Button>
                      ))}
                    </ButtonGroup>
                  )}
                </Col>
                <Col sm={10}>
                  {viewexames.length > 0 && (
                    <Chart
                      chartType="LineChart"
                      width="100%"
                      height="600px"
                      data={chartExames}
                      options={{ series: [{ color: '#F0011F' }] }}
                    />
                  )}
                </Col>
              </Row>
            )}

            {showTabelaExamesLab && (
              <>
                {uniqueExames.length > 0 && (
                  <ButtonGroup size="sm" style={{ flexWrap: 'wrap' }}>
                    {uniqueExames.map(exame => (
                      <Button
                        size="sm"
                        variant="outline-primary"
                        key={exame.EXAME}
                        onClick={() => handleExibirTabelaExames(exame)}
                      >
                        {exame.EXAME}
                      </Button>
                    ))}
                  </ButtonGroup>
                )}
                <Table responsive="sm" striped bordered hover size="sm">
                  <thead>
                    <tr className="text-center">
                      <th>EXAME</th>
                      <th>DATA</th>
                      <th>RESULTADO</th>
                      <th>OBSERVAÇÃO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableExames?.map(lab => (
                      <tr
                        key={lab.EXAME}
                        className="text-center"
                        style={{ backgroundColor: getRandomColor(lab) }}
                      >
                        <td>{lab?.EXAME}</td>
                        <td>{lab?.dataExame}</td>
                        <td>{lab?.VALOR}</td>
                        <td>{lab?.RESULTADO}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}

            {showTodosExamesLab && (
              <Table responsive="sm" striped bordered hover size="sm">
                <thead>
                  <tr className="text-center">
                    <th>EXAME</th>
                    <th>DATA</th>
                    <th>RESULTADO</th>
                    <th>OBSERVAÇÃO</th>
                  </tr>
                </thead>
                <tbody>
                  {tabelaexames?.map(lab => (
                    <tr
                      key={lab.EXAME}
                      className="text-center"
                      style={{ backgroundColor: getRandomColor(lab) }}
                    >
                      <td>{lab?.EXAME}</td>
                      <td>{lab?.dataExame}</td>
                      <td>{lab?.VALOR}</td>
                      <td>{lab?.RESULTADO}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                onClick={handleExcluirZerados}
                size="sm"
                variant="warning"
              >
                Limpar Zerados e Gravar Exames
              </Button>
            </div>

            <hr />

            <Table responsive="sm" striped bordered hover size="sm">
              <thead>
                <tr className="text-center">
                  <th>CODLAB</th>
                  <th>CODEXAME</th>
                  <th>DATA</th>
                  <th>EXAME</th>
                  <th>RESULTADO</th>
                  <th>OBSERVAÇÃO</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody>
                {laboratoriais?.map((lab, index) => (
                  <tr key={lab.CODLABOR} className="text-center">
                    <td>{lab?.CODLABOR}</td>
                    <td>{lab?.CODEXAME}</td>
                    <td>
                      {format(parseISO(lab?.DATALABOR), 'dd/MM/yyyy', {
                        locale: pt,
                      })}
                    </td>
                    <td>{lab?.EXAME}</td>
                    <td>
                      <Form.Control
                        id={index}
                        name="toggleValor"
                        autoComplete="off"
                        pattern="[0-9]*"
                        type="number"
                        onBlur={e => {
                          e.preventDefault();
                          if (isNaN(e.target.value)) {
                            toast.error('Campo aceita somente Números!');
                            toggleValor[index].select();
                          } else {
                            const updValor = laboratoriais.map(labor =>
                              labor.CODLABOR === lab.CODLABOR
                                ? { ...labor, VALOR: Number(e.target.value) }
                                : labor
                            );
                            setLaboratoriais(updValor);
                          }
                        }}
                        onWheel={e => e.currentTarget.blur()}
                        onKeyDown={e => {
                          if (
                            [
                              'ArrowUp',
                              'ArrowDown',
                              'ArrowLeft',
                              'ArrowRight',
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }

                          if (e.key === 'ArrowUp') {
                            if (index === 0) {
                              toggleValor[index].focus();
                              toggleValor[index].select();
                            } else {
                              toggleValor[index - 1].focus();
                              toggleValor[index - 1].select();
                            }
                          } else if (
                            e.key === 'ArrowDown' &&
                            index < laboratoriais.length - 1
                          ) {
                            if (index === 0) {
                              toggleValor[index + 1].focus();
                              toggleValor[index + 1].select();
                            } else {
                              toggleValor[index + 1].focus();
                              toggleValor[index + 1].select();
                            }
                          } else if (e.key === 'ArrowLeft') {
                            toggleResultado[index].select();
                          } else if (e.key === 'ArrowRight') {
                            toggleResultado[index].select();
                          }
                        }}
                        defaultValue={lab?.VALOR === 0 ? '' : lab?.VALOR}
                      />
                    </td>
                    <td>
                      <Form.Control
                        id={lab?.CODLABOR}
                        name="toggleResultado"
                        autoComplete="off"
                        type="text"
                        onBlur={e => {
                          const updResultado = laboratoriais.map(l =>
                            l.CODLABOR === lab.CODLABOR
                              ? { ...l, RESULTADO: e.target.value }
                              : l
                          );
                          setLaboratoriais(updResultado);
                        }}
                        onKeyDown={e => {
                          if (e.key === 'ArrowUp') {
                            if (index === 0) {
                              toggleResultado[index].focus();
                              toggleResultado[index].select();
                            } else {
                              toggleResultado[index - 1].focus();
                              toggleResultado[index - 1].select();
                            }
                          } else if (
                            e.key === 'ArrowDown' &&
                            index < laboratoriais.length - 1
                          ) {
                            if (index === 0) {
                              toggleResultado[index + 1].focus();
                              toggleResultado[index + 1].select();
                            } else {
                              toggleResultado[index + 1].focus();
                              toggleResultado[index + 1].select();
                            }
                          } else if (e.key === 'ArrowLeft') {
                            toggleValor[index].select();
                          } else if (e.key === 'ArrowRight') {
                            toggleValor[index].select();
                          }
                        }}
                        defaultValue={lab?.RESULTADO}
                      />
                    </td>
                    {lab.CODEXAME === 33 && (
                      <td>
                        <Button
                          onClick={() => {
                            let valorCT = 0;
                            let valorHDL = 0;
                            let valorTRI = 0;
                            let valorLDL = 0;
                            laboratoriais.forEach(labo => {
                              if (labo.CODEXAME === 1) valorCT = labo.VALOR;
                              if (labo.CODEXAME === 2) valorHDL = labo.VALOR;
                              if (labo.CODEXAME === 4) valorTRI = labo.VALOR;
                            });
                            valorLDL = valorCT - valorHDL - valorTRI / 5;

                            const updValor = laboratoriais.map(labor =>
                              labor.CODEXAME === 33
                                ? { ...labor, VALOR: valorLDL }
                                : labor
                            );
                            setLaboratoriais(updValor);
                          }}
                        >
                          Calc
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            <Card.Footer className="text-center">
              <i>Conferido e assinado eletronicamente por: </i>
              <strong>
                {prefixo(atual)} {atual?.REALIZOU}
              </strong>{' '}
              <br />
              <i>
                Assinatura Digital: {md5(JSON.stringify(laboratoriais || ''))}
              </i>
            </Card.Footer>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ExamesLaboratoriaisModal;
